const autoNgTemplateLoaderTemplate1 = require('./superdashboard.template.html');

'use strict';

import { NAVIGATION_ICON } from '../../modules/shared/constants/system/navigationIcons';

(function () {
    angular
        .module('app.superDashboard', [])
        .config(superDashboardConfig);

    superDashboardConfig.$inject = ['$routeProvider'];

    function superDashboardConfig($routeProvider) {
        $routeProvider
            .when('/superuser-dashboard', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'SuperDashboardController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: null,
                    breadcrumbs: [
                        { label: 'Dashboard', icon: NAVIGATION_ICON.DASHBOARD }
                    ]
                }
            })
    }
})();
